import { useAuth } from '@/hooks/useAuth'

/**
 * Shown to someone who signed up through a referral and is waiting to be let
 * in.
 *
 * They are deliberately allowed to use the portal while they wait — it is where
 * they turn on notifications, which is how they will find out they are approved.
 * What they cannot do is watch anything, so the banner says exactly that rather
 * than leaving them to discover it when a stream fails.
 */
export function PendingApprovalBanner() {
  const { user } = useAuth()
  if (user?.approvalState !== 'pending') return null

  return (
    <div className="border-b border-warn/30 bg-warn-dim">
      <div className="mx-auto max-w-6xl px-4 py-2.5">
        <p className="signage text-[10px] text-warn">Waiting for approval</p>
        <p className="mt-0.5 text-xs text-muted">
          Your account is in the queue. You can look around and turn on notifications — we will tell
          you the moment you can start watching.
        </p>
      </div>
    </div>
  )
}
